import { fadeAnimation, fadePulseAnimation, slideAnimation } from "@/core/modules/animations.module";
import { SessionService } from "@/core/services/security/session.service";
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Component({
    selector: "app-card-info-page",
    templateUrl: "./card-info-page.component.html",
    styleUrls: ["./card-info-page.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: [slideAnimation, fadeAnimation, fadePulseAnimation],
    standalone: false,
})
export class CardInfoPageComponent implements OnInit {
    // Inputs
    @Input("visible") visible: boolean = false;
    @Input("cardId") cardId: string = "";
    @Input("header") header: string = "";
    @Input("subheader") subheader: string = "";
    @Input("description") description: string = "";
    // Outputs
    @Output("onInitState") onInitState: EventEmitter<boolean> =
        new EventEmitter();
    @Output("onClose") onClose: EventEmitter<boolean> = new EventEmitter();

    optionsCloseCardInfo: Array<any> = [
        {
            label: "Fechar Apenas",
            icon: "pi pi-times",
            command: () => this.closeCardInfoPage(false),
        },
        {
            label: "Não Mostrar Novamente",
            icon: "pi pi-ban",
            command: () => this.closeCardInfoPage(true),
        },
    ];

    constructor(
        private cookieService: CookieService,
        private sessionService: SessionService
    ) {}

    ngOnInit(): void {
        this.isShowCardInfoPage();
    }

    isShowCardInfoPage() {
        const param = this.cookieService.get(
            this.sessionService.createNameCookieWithDomain(this.cardId)
        );
        if (param) {
            this.visible = false;
        } else {
            this.visible = true;
        }
        this.onInitState.emit(this.visible);
    }

    closeCardInfoPage(closeAwlays: boolean) {
        this.visible = false;
        if (closeAwlays) {
            this.cookieService.set(
                this.sessionService.createNameCookieWithDomain(this.cardId),
                JSON.stringify(closeAwlays)
            );
        }
    }

    slideAnimationDone(event: AnimationEvent) {
        this.onClose.emit(this.visible);
    }
}
